import { FontSizes, FontWeights } from '@picsart/rc/fonts';
import createUseStyles from '@picsart/rc/create';
import { mediaQuery } from '@picsart/rc/helpers';
import { BreakPoints, Spacings } from '@picsart/rc/enums';

const useHeaderStyles = createUseStyles(
  {
    root: {
      minHeight: 74,
      width: '100%',
      margin: '0 auto',
      boxShadow: '6px 0px 20px -14px var(--backgrounds-negative)',
      borderBottom: '1px solid var(--absolute-white-base-action)',
      padding: '20px 35px',
      position: 'fixed',
      top: 0,
      left: 0,
      display: 'flex',
      backgroundColor: 'var(--backgrounds-positive)',
      zIndex: 4,

      [mediaQuery(BreakPoints.Medium)]: {
        padding: '20px 15px',
      },
    },
    wrap: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    contentLeft: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '0',
    },
    contentRight: {},
    logo: {
      width: 104,
      height: 24,
      outline: 'none',
    },
    logoLink: {
      display: 'flex',
      marginRight: Spacings.Size_4,
      outline: 'none',
    },
    blogTitle: {
      color: 'var(--texts-negative)',
      fontSize: FontSizes.Size_15,
      fontWeight: FontWeights.Light,
      lineHeight: '21px',
      letterSpacing: 'normal',
      marginBottom: '-5px',
    },
    mobileMenuIcon: {
      width: '24px',
      marginRight: '21px',
      cursor: 'pointer',
    },
  },
  { name: 'header' },
);
export default useHeaderStyles;
